module.exports = __webpack_public_path__ + "media/bootstrap-icons/file-spreadsheet-fill-9bc28dbc.svg";